import React, {useRef, useState} from "react";
import {ClickAwayListener, MenuItem, MenuList, Paper, Popper, TextField, Typography} from "@mui/material";
import {detectVariableTrigger} from "../../../../../utils/functions";
const OPEN = "{{";
const CLOSE = "}}";

export const VariableTextField = ({value = "", onChange, variables = [], ...rest}) => {
    const inputRef = useRef(null);
    const [trigger, setTrigger] = useState(null);
    const [highlighted, setHighlighted] = useState(0);

    const suggestions = trigger
        ? variables.filter(v => v?.toLowerCase().startsWith(trigger.query.toLowerCase()))
        : [];

    const open = !!trigger && suggestions.length > 0;

    const closePopup = () => setTrigger(null);

    const handleChange = (e) => {
        const text = e.target.value;
        const caret = e.target.selectionStart;
        const t = detectVariableTrigger(text, caret);
        setTrigger(t);
        setHighlighted(0);
        onChange?.(text);
    };

    const insert = (variable) => {
        if (!trigger) return;
        const inserted = OPEN + variable + CLOSE;
        const newValue = value.slice(0, trigger.start) + inserted + value.slice(trigger.end);
        onChange?.(newValue);
        closePopup();
        const caretPos = trigger.start + inserted.length;
        requestAnimationFrame(() => {
            const el = inputRef.current;
            if (el) {
                el.focus();
                el.setSelectionRange(caretPos, caretPos);
            }
        });
    };

    const handleKeyDown = (e) => {
        if (!open) return;
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlighted(i => (i + 1) % suggestions.length);
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlighted(i => (i - 1 + suggestions.length) % suggestions.length);
        } else if (e.key === "Enter") {
            e.preventDefault();
            insert(suggestions[highlighted]);
        } else if (e.key === "Escape") {
            e.preventDefault();
            closePopup();
        }
    };

    return (
        <>
            <TextField
                {...rest}
                value={value}
                inputRef={inputRef}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
            <Popper
                open={open}
                anchorEl={inputRef.current}
                placement={"bottom-start"}
                style={{zIndex: 1400, width: inputRef.current?.offsetWidth}}
            >
                <ClickAwayListener onClickAway={closePopup}>
                    <Paper elevation={3} sx={{maxHeight: 220, overflowY: "auto", mt: 0.5}}>
                        <MenuList dense>
                            {suggestions.map((v, i) => (
                                <MenuItem
                                    key={v}
                                    selected={i === highlighted}
                                    onMouseDown={e => e.preventDefault()}
                                    onClick={() => insert(v)}
                                >
                                    <Typography variant={"body2"} sx={{fontFamily: "monospace"}}>{v}</Typography>
                                </MenuItem>
                            ))}
                        </MenuList>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </>
    );
};
